const cleanups = new WeakMap<object, () => void>();

interface F7Page {
  el: HTMLElement;
}
interface F7WithNavbar {
  theme: string;
  navbar: { getElByPage: (page: F7Page) => HTMLElement | undefined };
}

function pageInit(this: F7WithNavbar, page: F7Page) {
  if (this.theme !== 'md') return;

  const pageEl: HTMLElement = page.el;
  const navbar = this.navbar.getElByPage(page) ?? null;
  const pageContent = pageEl.querySelector('.page-content') as HTMLElement | null;

  if (!navbar || !pageContent) return;

  const onScroll = () => {
    navbar.classList.toggle('navbar-elevated', pageContent.scrollTop > 0);
  };

  pageContent.addEventListener('scroll', onScroll, { passive: true });

  cleanups.set(page, () => {
    pageContent.removeEventListener('scroll', onScroll);
    navbar.classList.remove('navbar-elevated');
  });
}

function pageBeforeRemove(this: F7WithNavbar, page: F7Page) {
  cleanups.get(page)?.();
  cleanups.delete(page);
}

export const mdNavbarElevation = { pageInit, pageBeforeRemove };
